module.exports = __webpack_public_path__ + "img/2024-07-01c_5.8c61d622.jpg";